import {match} from 'ts-pattern';

import {isNotNil} from 'ramda';

import type {DataGridRow} from '@dms/api/core';

import {parseDate} from 'shared/web';

import {readDataGridCellString} from './readDataGridCellString';

export function readDataGridCellDateString(row: DataGridRow, keys: readonly string[]) {
  return keys
    .map((key) => {
      const value = readDataGridCellString(row, [key]);
      const date = parseDate(value);

      return match(date)
        .when(
          (parsedDate): parsedDate is Date =>
            parsedDate !== null && !Number.isNaN(parsedDate.getTime()),
          () => value
        )
        .otherwise(() => undefined);
    })
    .find(isNotNil);
}
